

































import { Vue, Prop, Component } from 'vue-property-decorator';
import { DiscountViewObject, PriceDetailedViewObject } from '@/types/apiServerContract';
import detailedPriceFetchService from '@/project/product/services/detailedPriceFetch.service';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';
import { PriceSimpleDataExtended } from '@/project/product/services/simplePriceFetch.service';

@Component({
    components: { SpinnerOverlay }
})
export default class ProductTileDiscounts extends Vue {
    @Prop({ required: true, type: String }) itemId!: string;
    @Prop({ required: true }) price!: PriceSimpleDataExtended;

    private discountsLoaded: boolean = false;
    private priceDetailed: PriceDetailedViewObject | null = null;

    get hasQuantityDiscounts() {
        return this.price?.hasQuantityDiscounts ?? false;
    }

    private getNextQuantity(index: number) {
        return this.priceDetailed && this.priceDetailed.discounts
            ? this.priceDetailed.discounts[index + 1].quantity : 0;
    }

    get quantityDiscounts(): DiscountViewObject[] {
        return this.priceDetailed?.discounts ?? [];
    }

    private async getDetailedPrice() {
        if (this.priceDetailed) return;

        try {
            const request = detailedPriceFetchService.requestData(this.itemId);
            const result = await request.promise;
            this.priceDetailed = Object.freeze(result);
        } finally {
            this.discountsLoaded = true;
        }
    }
}
